module.exports = __webpack_public_path__ + "static/media/head.55ae1d6d.svg";